export default (templateData) => ({
  name: templateData?.bankName,
  country: templateData?.bankCountry,
  bic: templateData?.bic
});
